import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, isRef as _isRef, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "l-contents" }
const _hoisted_2 = { class: "l_header" }
const _hoisted_3 = { class: "l-contents__body" }
const _hoisted_4 = { class: "l-Snackbar" }
const _hoisted_5 = {
  key: 0,
  class: "dialogArea"
}

import { ref, computed, inject, Ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { usePortalStore } from '@/store'
import { useKeyboardStore } from '@/store/keyboard'
import { LoadingStore, useLoadingStore, loadingReset } from '@/store/loading'
import { useSnackbarStore, runSnackBar } from '@/store/snackbar'

import Header from '@/components/Header/Header.vue'
import Footer from '@/components/Footer/Footer.vue'
import SlotDialog from '@/components/SlotDialog/SlotDialog.vue'
import SoftwareKeyboard from '@/components/SoftwareKeyboard/SoftwareKeyboard.vue'
import YomokkaNavi from '@/components/YomokkaNavi/YomokkaNavi.vue'
import ScrollTopButton from '@/components/ScrollTopButton/ScrollTopButton.vue'
import AppLoading from '@/components/AppLoading/AppLoading.vue'

import { useConfirm } from '@/composables/useConfirm'
import { injectionKeys } from '@/constants/injectionKeys'


export default /*#__PURE__*/_defineComponent({
  __name: 'BasePage',
  setup(__props) {

const portal = usePortalStore()
const route = useRoute()
const router = useRouter()

const isWhitelist = inject<Ref<boolean>>(injectionKeys.isWhitelist)!
const isNextGiga = inject<Ref<boolean>>(injectionKeys.isNextGiga)!

// 404,500,503エラー判定
const isErrorPage = computed(() => {
  if (route.name === 'InternalServerError') return true
  if (route.name === 'ServiceUnavailable') return true
  if (route.name === 'NotFound') return true
  return false
})

// TODO: footer非表示のパターンがあるか
const footer = ref(true)

// キーボード
const keyboardStore = useKeyboardStore()
const isKeyboardShow = computed(() => keyboardStore.getShow)
const onChangeKeyboard = () => {
  keyboardStore.toggleShow()
}

// ローディング
const loadingStore = useLoadingStore()
const loadingStateGlobal = ref<LoadingStore | null>()
loadingStore.$subscribe(async (mutation, state) => {
  loadingStateGlobal.value = state.name ? loadingReset : state
})

// 通知
const snackbarStore = useSnackbarStore()
const snackbarPosition = ref<boolean>()
snackbarStore.$subscribe(async (mutation, state) => {
  snackbarPosition.value = state.isModal
})
// 通知処理呼び出し
runSnackBar(snackbarStore)

// ログアウト
const { isConfirming, confirm, disagree, agree } = useConfirm()
const logout = async () => {
  if (await confirm()) {
    await router.push({ name: 'Logout' })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Header, {
          "onClick:logout": _cache[0] || (_cache[0] = ($event: any) => (logout()))
        })
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["l-contents__wrap", { 'is-error': _unref(isErrorPage) }])
      }, [
        (!_unref(isErrorPage))
          ? (_openBlock(), _createBlock(YomokkaNavi, {
              key: 0,
              points: _unref(portal).user?.point,
              "onUpdate:keyboard": onChangeKeyboard
            }, null, 8, ["points"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["l-contents__inner", { 'is-error': _unref(isErrorPage) }])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_view)
          ]),
          (!_unref(isErrorPage))
            ? (_openBlock(), _createBlock(ScrollTopButton, {
                key: 0,
                keyboard: _unref(isKeyboardShow),
                "onUpdate:keyboard": _cache[1] || (_cache[1] = ($event: any) => (_isRef(isKeyboardShow) ? (isKeyboardShow).value = $event : null))
              }, null, 8, ["keyboard"]))
            : _createCommentVNode("", true),
          (footer.value)
            ? (_openBlock(), _createBlock(Footer, { key: 1 }))
            : _createCommentVNode("", true),
          _createVNode(SoftwareKeyboard, {
            keyboard: _unref(isKeyboardShow),
            "onUpdate:keyboard": _cache[2] || (_cache[2] = ($event: any) => (_isRef(isKeyboardShow) ? (isKeyboardShow).value = $event : null)),
            class: "l-keyboard"
          }, null, 8, ["keyboard"])
        ], 2)
      ], 2)
    ]),
    _createElementVNode("aside", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["l-Snackbar__wrap", { 'is-modal': snackbarPosition.value }])
      }, null, 2)
    ]),
    _createVNode(_Transition, { name: "dialog" }, {
      default: _withCtx(() => [
        (_unref(isConfirming))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(SlotDialog, {
                type: "confirm",
                title: "ログアウトしますか？",
                onAgree: _unref(agree),
                onCancel: _unref(disagree)
              }, null, 8, ["onAgree", "onCancel"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (loadingStateGlobal.value && loadingStateGlobal.value.loading)
          ? (_openBlock(), _createBlock(AppLoading, {
              key: 0,
              type: loadingStateGlobal.value.type
            }, null, 8, ["type"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})